import { StrictMode } from 'react'
import type { GatsbyBrowser } from 'gatsby'

import RootProviders from 'components/RootProviders'
import PageProviders from 'components/PageProviders'
import type { BottlePageContext } from 'pages/bottle/{ShopifyProductVariant.theme__value}'
import { isPathActive } from 'lib/urls'

type PageContext = Partial<BottlePageContext>
type GatsbyWithContext = GatsbyBrowser<object, PageContext>

// These providers are available in <Head>
export const wrapRootElement: NonNullable<
  GatsbyWithContext['wrapRootElement']
> = ({ element }) => (
  <StrictMode>
    <RootProviders>{element}</RootProviders>
  </StrictMode>
)

export const wrapPageElement: NonNullable<
  GatsbyWithContext['wrapPageElement']
> = ({ element, props }) => {
  const isLandingPage = isPathActive('/', props.location.pathname)
  const isMeetBottlePage = isPathActive('/meet/', props.location.pathname)

  // Enable background component to prevent white flash between routes
  const backgroundEnabled = isLandingPage || isMeetBottlePage

  // Handle meet & buy bottle page variants
  const initialVariant = props.pageContext['theme__value']

  return (
    <PageProviders
      backgroundEnabled={backgroundEnabled}
      initialVariant={initialVariant}
    >
      {element}
    </PageProviders>
  )
}
